<template>
  <div class="pg-radio-group" :class="{ showOhterGroupClass: showOtherClass }">
    <PgRadio
      :class="{ showOhterRadioClass: showOtherClass }"
      v-for="source in sources"
      :key="source.code"
      :value="value"
      :label="source.code"
      :text="source.name"
      :tip="source.tip"
      :disabled="source.disabled"
      @change="(v) => change(source.code, source, v)"
    >
    </PgRadio>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import { watch } from 'vue'
import { PgRadio } from '../../radio/index'
import { useRadioGroup } from '../hooks/index'
import { useFormItemValidate } from '../../form/hook/use-form-item-validate'

const emit = defineEmits(['input'])

const props = defineProps({
  /**
   * 当前已选中
   */
  value: {
    type: [String, Number, Boolean],
    default: '',
  },
  validateCustom: {
    type: Boolean,
    default: true,
  },
  /**
   * 数据源
   * [
   *  { code: 'NO', name: '否', default: true },
   *  { code: 'DAY', name: '按日每天自动生成结算单' },
   *  { code: 'MONTH', name: '按自然月末自动生成结算单' },
   * ]
   */
  sources: {
    type: Array,
    default() {
      return []
    },
  },
  showOtherClass: {
    type: Boolean,
    default: false,
  },
})

const { formItemsChange } = useFormItemValidate()
watch(
  () => props.value,
  () => {
    props.validateCustom && formItemsChange()
  }
)

const { init, change } = useRadioGroup({ props, emit })
init()
</script>

<style lang="scss">
@import '../style/radio-group.scss';
</style>
